import { render, staticRenderFns } from "./electric-ammeter-add.vue?vue&type=template&id=c5b5fb4c&scoped=true&"
import script from "./electric-ammeter-add.vue?vue&type=script&lang=js&"
export * from "./electric-ammeter-add.vue?vue&type=script&lang=js&"
import style0 from "./electric-ammeter-add.vue?vue&type=style&index=0&id=c5b5fb4c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5b5fb4c",
  null
  
)

export default component.exports